var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"items":_vm.dropdownDataSource.sort((a, b) => {
				return a[Object.keys(a)[0]].localeCompare(
					b[Object.keys(b)[0]]
				);
			}),"label":_vm.item.Label,"clearable":"","required":"","rules":[(v) => !!v || 'Is required'],"filter":_vm.searchDropdown},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v(" "+_vm._s(_vm.filterGroupByCriteriaItems(data.item))+" ")]}},{key:"item",fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.filterGroupByCriteriaItems(item))+" ")]}}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }